var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_form" },
    [
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center px-2 p-lg-5 mt-2",
              attrs: { lg: "12" }
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "px-xl-2 mx-auto",
                  attrs: { sm: "12", md: "8", lg: "6" }
                },
                [
                  _c(
                    "b-card",
                    [
                      _c(
                        "b-card-title",
                        {
                          staticClass: "mb-1 font-weight-bold text-center",
                          attrs: { "title-tag": "h2" }
                        },
                        [_vm._v(" Olá, bem-vindo(a)! ")]
                      ),
                      !_vm.generalOrientation
                        ? _c(
                            "b-card-text",
                            { staticClass: "mb-2 text-center" },
                            [
                              _vm._v(" Formulário de Intimidação Sistemática"),
                              _c("br"),
                              _c("br")
                            ]
                          )
                        : _vm._e(),
                      _vm.generalOrientation
                        ? _c("b-card-text", {
                            directives: [
                              {
                                name: "html-safe",
                                rawName: "v-html-safe",
                                value: _vm.generalOrientation,
                                expression: "generalOrientation"
                              }
                            ],
                            staticClass: "mb-2"
                          })
                        : _vm._e(),
                      _c(
                        "validation-observer",
                        { ref: "requestForm" },
                        [
                          _c(
                            "b-form",
                            {
                              staticClass: "mb-1 mt-2",
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.send($event)
                                }
                              }
                            },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "systematic_intimidation.unit"
                                    ),
                                    "label-for": "unity"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: _vm.$t(
                                        "systematic_intimidation.unit"
                                      ),
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "v-select",
                                              {
                                                ref: "select-legal-entity",
                                                staticClass: "required-select",
                                                attrs: {
                                                  options: _vm.listLegal,
                                                  label: "name"
                                                },
                                                model: {
                                                  value: _vm.legalEntity,
                                                  callback: function($$v) {
                                                    _vm.legalEntity = $$v
                                                  },
                                                  expression: "legalEntity"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "no-options"
                                                    },
                                                    slot: "no-options"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("msg_none"))
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "systematic_intimidation.link_profile"
                                    ),
                                    "label-for": "link_profile"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: _vm.$t(
                                        "systematic_intimidation.link_profile"
                                      )
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "link_profile",
                                                name: "linkProfile"
                                              },
                                              model: {
                                                value: _vm.linkProfile,
                                                callback: function($$v) {
                                                  _vm.linkProfile = $$v
                                                },
                                                expression: "linkProfile"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "systematic_intimidation.description"
                                    ),
                                    "label-for": "description"
                                  }
                                },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      id: "description",
                                      state: _vm.description.length >= 10,
                                      placeholder: _vm.$t("form_min_caracter"),
                                      rows: "4"
                                    },
                                    model: {
                                      value: _vm.description,
                                      callback: function($$v) {
                                        _vm.description = $$v
                                      },
                                      expression: "description"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("div", { staticClass: "vx-row pt-2" }, [
                                _c(
                                  "div",
                                  { staticClass: "vx-col w-full" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "waves-effect float-right",
                                        attrs: {
                                          type: "submit",
                                          variant: "primary"
                                        }
                                      },
                                      [_vm._v(" Enviar ")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-card-footer",
                        { staticClass: "text-right" },
                        [
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v("Desenvolvido por:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-link",
                            {
                              attrs: {
                                href: "https://securamdata.com",
                                target: "_brank"
                              }
                            },
                            [_vm._v("securamdata.com")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }